/**
 * 登録のステップ
 */
export const REGISTRATION_STEP = {
  INPUT: 'input',
  CONFIRMATION: 'confirmation',
  RESULT: 'result',
} as const;

/**
 * 登録のステップのコード値
 */
export type RegistrationStep =
  typeof REGISTRATION_STEP[keyof typeof REGISTRATION_STEP];
